/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail price data meta reducer
 */

import {
  CITY_NAME_CHANGED,
  CLEAR_CITY_NAME,
  CLEAR_HOOD_NAME,
  HOOD_NAME_CHANGED,
} from '../../../currentSearch/modules/location/constants'
import {
  CLEAR_HOOD_PRICE_CHART_DATA,
  CLEAR_PRICE_CHART_DATA,
  DONE_FETCHING_CITY_PRICE_CHART_DATA,
  DONE_FETCHING_HOOD_PRICE_CHART_DATA,
  ERROR_FETCHING_CITY_PRICE_CHART_DATA,
  ERROR_FETCHING_HOOD_PRICE_CHART_DATA,
  SET_CITY_PRICE_CHART_DATA,
  SET_HOOD_PRICE_CHART_DATA,
  START_FETCHING_CITY_PRICE_CHART_DATA,
  START_FETCHING_HOOD_PRICE_CHART_DATA,
} from '../../constants/locale'
import { cityMetaReducerCreator } from '../meta/cityMetaReducerCreator'
import { hoodMetaReducerCreator } from '../meta/hoodMetaReducerCreator'

export const cityMetaReducer = cityMetaReducerCreator({
  errorFetching: ERROR_FETCHING_CITY_PRICE_CHART_DATA,
  cityNameChanged: CITY_NAME_CHANGED,
  clearCityName: CLEAR_CITY_NAME,
  clearData: CLEAR_PRICE_CHART_DATA,
  startFetching: START_FETCHING_CITY_PRICE_CHART_DATA,
  doneFetching: DONE_FETCHING_CITY_PRICE_CHART_DATA,
  setData: SET_CITY_PRICE_CHART_DATA,
})

export const hoodMetaReducer = hoodMetaReducerCreator({
  errorFetching: ERROR_FETCHING_HOOD_PRICE_CHART_DATA,
  cityNameChanged: CITY_NAME_CHANGED,
  clearCityName: CLEAR_CITY_NAME,
  clearHoodName: CLEAR_HOOD_NAME,
  clearPriceChartData: CLEAR_PRICE_CHART_DATA,
  clearHoodPriceChartData: CLEAR_HOOD_PRICE_CHART_DATA,
  hoodNameChanged: HOOD_NAME_CHANGED,
  startFetching: START_FETCHING_HOOD_PRICE_CHART_DATA,
  doneFetching: DONE_FETCHING_HOOD_PRICE_CHART_DATA,
  setData: SET_HOOD_PRICE_CHART_DATA,
})
